import type React from 'react';
import { BranchStepView } from './BranchStepView';
import { useBranchStep } from './useBranchStep';

/** `/onboarding/branch`: which branch the file is for. */
export const BranchStep: React.FC = () => (
    <BranchStepView {...useBranchStep()} />
);
